<template>
  <div class="history">
    <div class="historyheader">
      <div class="historyheaderleft">
        <p :class="index ? 'on' : ''" @click="classchange(true)">文字创作</p>
        <p :class="index ? '' : 'on'" @click="classchange(false)">视频创作</p>
      </div>
      <div class="historyheaderright">
        <div v-if="index">
          <el-input
            style="width: 200px"
            v-model="articleform.keyword"
            placeholder="搜索创作"
            prefix-icon="el-icon-search"
          ></el-input>
          <p>模板</p>
          <el-select v-model="articleform.tid" @change="changefun">
            <el-option
              v-for="(item, index) in list"
              :key="index"
              :value="item.id"
              :label="item.title"
            >
              <div class="option">
                <!-- <img :src="item.icon" alt=""> -->
                <span>{{ item.title }}</span>
              </div>
            </el-option>
          </el-select>
        </div>
        <div v-if="!index">
          <p>分类</p>
          <el-select v-model="videoform.tid">
            <el-option
              v-for="(item, index) in videolist"
              :key="index"
              :value="item.id"
              :label="item.title"
            >
              <div class="option">
                <!-- <img :src="item.icon" alt=""> -->
                <span>{{ item.title }}</span>
              </div>
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <el-scrollbar ref="scrollbar">
      <div v-show="index">
        <div class="taskflex">
          <div
            class="taskbox"
            v-for="(item, index) in task"
            :key="index"
            @click="showdetail(item)"
          >
            <div class="taskheader">
              <div class="taskheaderright">
                <img :src="item.image" alt="" />
                <!-- <span>{{item.title}}</span> -->
              </div>
              <div class="taskheaderleft">
                <span>{{ item.createtime }}</span>
                <i
                  class="el-icon-copy-document"
                  @click.stop="copy($event, item.content)"
                ></i>
                <i class="el-icon-delete" @click.stop="del(item.id)"></i>
              </div>
            </div>
            <div class="taskcontent">
              <p class="problem">{{ item.title }}</p>
              <div class="answer">{{ item.content }}</div>
            </div>
          </div>
        </div>
        <div style="text-align: center">
          <el-pagination
            layout="prev, pager, next"
            :total="tasktotal"
            :current-page="Number(articleform.page)"
            @current-change="articleGetUserCenterList"
          >
          </el-pagination>
        </div>
      </div>
      <div v-show="!index">
        <div class="videoflex">
          <div
            class="taskbox"
            v-for="(item, index) in video"
            :key="index"
            @click="showvideo(item.id)"
          >
            <div class="taskheader">
              <img :src="item.video_image" alt="" class="thumb" />
              <img
                src="@/assets/history/start.png"
                alt=""
                class="start"
                v-if="item.status == 2"
              />
              <!-- <span class="time">{{item.createtime}}</span> -->
            </div>
            <div class="taskcontent">
              <div class="problem">
                <p v-show="item.type == 1">
                  <img src="../../assets/fun/60007.png" alt="" />
                  <span>文生视频</span>
                </p>
                <p v-show="item.type == 2">
                  <img src="../../assets/fun/60008.png" alt="" />
                  <span>照片数字人</span>
                </p>
                <p v-show="item.type == 2">
                  <img src="../../assets/fun/60009.png" alt="" />
                  <span>AI换脸秀</span>
                </p>
                <span>{{ item.title }}</span>
              </div>
              <div class="answer">创建于{{ item.createtime }}</div>
            </div>
          </div>
        </div>
        <div style="text-align: center">
          <el-pagination
            layout="prev, pager, next"
            :total="videototal"
            :current-page="Number(videoform.page)"
            @current-change="videoGetUserCenterList"
          >
          </el-pagination>
        </div>
      </div>

      <!-- <p class="tip">到底了</p> -->
    </el-scrollbar>
    <videoplay v-if="videoplaystatus" @colsevideo="colsevideo" :videoid="videoid"></videoplay>
    <el-drawer
      direction="rtl"
      :visible.sync="drawer"
      :with-header="false"
      :size="800"
    >
      <div class="drawerbox">{{ selectdata.content }}</div>
    </el-drawer>
  </div>
</template>

<script>
import videoplay from "@/components/videoplay";
import { articleGetUserCenterList, videoGetUserCenterList } from "@/api/user";
import { articleDelete } from "@/api/copywriting";
import Clipboard from "clipboard";
export default {
  components: {
    videoplay,
  },
  data() {
    return {
      videoid:1,
      videototal: 10,
      tasktotal: 10,
      drawer: false,
      videoPage: 1,
      articlePage: 1,
      articleform: {
        keyword: "",
        tid: "",
        page: 1,
      },
      videoform: {
        tid: "",
        page: 1,
      },
      videoplaystatus: false,
      index: true,
      task: [],
      video: [],
      list: [],
      videolist: [],
      selectdata: {},
    };
  },
  mounted() {
    // this.scrollbar(); //el-scrollbar触底事件
    this.articleGetUserCenterList(1);
    window.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        this.articleGetUserCenterList(1);
      }
    });
    if (this.$route.params.type && this.$route.params.type == 2) {
      this.index = false;
	  this.videoGetUserCenterList();
    }
  },
  methods: {
    showvideo(id){
        this.videoid = id
        this.videoplaystatus = true
    },
    changefun() {
      this.articleform.page = 1;
      this.articleGetUserCenterList(1);
    },
    del(id) {
      articleDelete({ id: id }).then((res) => {
        this.articleGetUserCenterList();
      });
    },
    copy(event, content) {
      const clipboard = new Clipboard(event.target, {
        text: () => content,
      });
      clipboard.on("success", () => {
        clipboard.destroy();
        this.$message({
          message: "复制成功",
          type: "success",
          duration: 3 * 1000,
        });
      });
      clipboard.on("error", () => {
        clipboard.destroy();
        this.$message({
          message: "复制失败",
          type: "error",
          duration: 3 * 1000,
        });
      });
      clipboard.onClick(event);
    },
    showdetail(data) {
        console.log(data)
      this.drawer = true;
      this.selectdata = data;
    },
    classchange(status) {
      this.index = status;
      if (this.index) {
        this.articleform.page = 1;
        this.articleGetUserCenterList();
      } else {
        this.videoform.page = 1;
        this.videoGetUserCenterList();
      }
    },
    colsevideo() {
      this.videoplaystatus = false;
    },
    articleGetUserCenterList(page) {
      this.articleform.page = page
      articleGetUserCenterList(this.articleform).then((res) => {
        // if(status){
        //     this.task.concat(res.data.list.data)
        // }else{
        this.task = res.data.list.data;
        // }
        this.list = res.data.template;
        this.tasktotal = res.data.list.total;
      });
    },
    videoGetUserCenterList(page) {
      this.videoform.page = page
      videoGetUserCenterList(this.videoform).then((res) => {
        // if(status){
        //     this.video.concat(res.data.list.data)
        // }else{
        this.video = res.data.list.data;
        // }
        this.videolist = res.data.template;
        this.videototal = res.data.list.total;
      });
    },
    scrollbar() {
      this.$refs.scrollbar.handleScroll = () => {
        var wrap = this.$refs.scrollbar.wrap;
        this.$refs.scrollbar.moveY = (wrap.scrollTop * 100) / wrap.clientHeight;
        this.$refs.scrollbar.moveX = (wrap.scrollLeft * 100) / wrap.clientWidth;
        let poor = wrap.scrollHeight - wrap.clientHeight;
        if (
          poor == parseInt(wrap.scrollTop) ||
          poor == Math.ceil(wrap.scrollTop) ||
          poor == Math.floor(wrap.scrollTop)
        ) {
          switch (this.index) {
            case true:
              if (this.articleform.page < this.articlePage) {
                this.articleform.page++;
                this.articleGetUserCenterList(true);
              }
              break;
            case false:
              if (this.videoform.page < this.videoPage) {
                this.videoform.page++;
                this.videoGetUserCenterList(true);
              }
              break;
          }
        }
      };
    },
  },
};
</script>

<style lang="less">
@media (min-width: 1600px) {
  .history {
    .taskflex {
      .taskbox {
        flex: 0 0 24%;
      }
    }
  }
  .history {
    .videoflex {
      .taskbox {
        flex: 0 0 19%;
      }
    }
  }
}
@media (max-width: 1600px) {
  .history {
    .taskflex {
      .taskbox {
        flex: 0 0 32%;
      }
    }
  }
  .history {
    .videoflex {
      .taskbox {
        flex: 0 0 24%;
      }
    }
  }
}
.option {
  width: 100%;
  display: inline-flex;
  align-items: center;
  img {
    width: 22px;
    margin-right: 12px;
  }
}
.drawerbox {
  padding: 40px;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  line-height: 1.8;
}
.history {
  width: 100%;
  .historyheader {
    padding: 20px 32px 20px;
    display: flex;
    justify-content: space-between;
    .historyheaderleft {
      display: flex;
      width: 200px;
      justify-content: space-between;
      p {
        color: rgb(96, 98, 102);
        font-size: 20px;
        cursor: pointer;
      }
      .on {
        color: #333;
        position: relative;
      }
      .on::after {
        content: "";
        position: absolute;
        display: block;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        border-radius: 3px;
        background: #2d8af5;
        width: 32px;
        height: 5px;
      }
    }
    .historyheaderright {
      div {
        display: flex;
        align-items: center;
        p {
          width: 80px;
          // padding: 0px 4px 0 20px;
          text-align: right;
          padding-right: 12px;
          box-sizing: border-box;
        }
      }
    }
  }
  .el-scrollbar {
    height: calc(100vh - 120px);
    .el-scrollbar__wrap {
      overflow-x: hidden;
      // padding-bottom: 122px;
    }
  }
  .tip {
    color: #999;
    text-align: center;
    font-size: 12px;
  }
  .taskflex {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    padding: 0px 32px 20px;
    .taskbox:hover {
      box-shadow: 0 0 10px rgba(63, 72, 150, 0.08);
    }
    .taskbox {
      width: 100%;
      height: 254px;
      background: #ffffff;
      border-radius: 10px;
      box-sizing: border-box;
      padding: 20px 24px 24px;
      border: 1px solid #f4f5f7;
      .taskheader {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .taskheaderright {
          display: flex;
          align-items: center;
          margin-right: 20px;
          img {
            width: 20px;
            height: 20px;
            margin-right: 8px;
          }
          span {
            font-weight: 700;
            font-size: 14px;
            line-height: 22px;
            color: #6f8792;
          }
        }
        .taskheaderleft {
          display: flex;
          align-items: center;
          justify-content: space-between;
          // flex: 1 0 10%;
          opacity: 0;
          span {
            padding-right: 8px;
            font-weight: 400;
            font-size: 11px;
            line-height: 18px;
            color: #b2b2b2;
            white-space: nowrap;
            border-right: 1px solid #b2b2b2;
          }
          i {
            margin-left: 12px;
            cursor: pointer;
          }
        }
      }
      .taskheader:hover {
        .taskheaderleft {
          opacity: 1;
        }
      }
      .taskcontent {
        .problem {
          font-weight: 700;
          line-height: 21px;
          color: #333940;
          margin: 16px 0;
          max-width: 284px;
          white-space: nowrap;
          overflow: hidden;//文本超出隐藏
          text-overflow: ellipsis;//文本超出省略号替代
        }
        .answer {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 7;
          overflow: hidden;
          font-weight: 400;
          font-size: 14px;
          color: #6f8792;
        }
      }
    }
  }

  .videoflex {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    padding: 0px 32px 20px;
    .taskbox {
      cursor: pointer;
      .taskheader {
        position: relative;
        min-height: 150px;
        overflow: hidden;
        .thumb {
          width: 100%;
          border-radius: 12px;
          display: block;
        }
        .start {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          opacity: 0;
        }
        .time {
          position: absolute;
          right: 4px;
          bottom: 4px;
          padding: 2px 4px;
          font-size: 12px;
          color: #fff;
          background: rgba(0, 0, 0, 0.6);
          border-radius: 4px;
        }
      }
      .taskcontent {
        .problem {
          display: flex;
          align-items: center;
          p {
            padding: 4px 8px;
            background-color: #f4f5f7;
            font-size: 12px;
            color: #4e5969;
            flex-shrink: 0;
            border-radius: 4px;
            gap: 4px;
            display: flex;
            align-items: center;
            margin-right: 6px;
            img {
              width: 14px;
            }
          }
          span {
            font-size: 14px;
          }
        }
        .answer {
          color: #999;
          font-size: 12px;
          margin-top: 4px;
        }
      }
    }
    .taskbox:hover {
      .start {
        opacity: 1;
      }
    }
  }
}
</style>